import axios from 'axios';
// @ts-ignore
//import * as SecureStore from "expo-secure-store";

import { endPoints,paymentEndpoints } from "../constant/Environment";
export const BASE_URL =  endPoints.apiBaseUrl; 
export const PAYMENT_BASE_URL =  paymentEndpoints.apiBaseUrl;       

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
      // Authorization: 'Bearer ' + sessionStorage.getItem('caroktajwt')
  }
});
export const axiosPaymnetInstance = axios.create({
  baseURL: PAYMENT_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
      // Authorization: 'Bearer ' + sessionStorage.getItem('caroktajwt')
  }
}); 

export const axiosFormInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  //  Authorization: 'Bearer ' + sessionStorage.getItem('caroktajwt')
  }
});
